<template>
    <div>
        <div v-if="showlistevent">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <!-- <h3 class="custom-20px-600 text-left mt-4">18 January, 2024</h3> -->
                        <h3 class="custom-24px-500 text-left">Event List</h3>
            <h4 class="custom-16px-500 text-left font-color-AEAEB2">Review and manage events before starting the matching process</h4>
                    </CCol>
                    <CCol sm="6">
                        <div class="text-right float-right mt-3">
                            <CButton class="btn button-Explore text-white text-right mb-3" @click="GoToEvent()">+ Create Event</CButton>
                        </div>
                    </CCol>
                    <CCol sm="3" v-for="(item, index) in tour" v-bind:key="item.Id" v-if="tour && tour.length > 0">
                        <CCard class="p-2" @click="showdetail(item)">
                            <div class="image-container">
                                <!-- Display the image -->
                                <img v-if="item.FilePath != null" :src="getThumbnail(index)" class="image" />
                                <img v-else src="../assets/img/photo1.png" class="image" />
                                <!-- Overlay text -->
                                <div class="overlay-text-right"><img src="../assets/img/smallicon/Location.png" width="20px" /> {{ item.Location }}</div>
                                <div class="overlay-text-left">{{ item.Category }}</div>
                            </div>
                            <CRow>
                                <CCol sm="6">
                                    <div class="custom-label-tag-blue-light mt-2">
                                        <img src="../assets/img/smallicon/Time Circle.png" width="20px" /> {{ item.Time }}
                                    </div>
                                </CCol>
                                <CCol sm="6">
                                    <div class="mt-2">
                                        <img style="width:20px" src="../assets/img/user.png" /> Registered
                                    </div>
                                </CCol>
                                <CCol sm="12">
                                    <h3 class="custom-14px-500 text-left mt-3">
                                        <b>{{ item.Title }}</b>
                                    </h3>
                                </CCol>
                                <CCol sm="8">
                                    <p class="custom-16px-600 text-left"><b>RM {{ item.Amount }}</b></p>
                                </CCol>
                            </CRow>
                        </CCard>
                    </CCol>
                    <CCol sm="12" v-if="tour && tour.length === 0" class="text-center custom-scroll-div">
                        <CCol>
                            <img src="../assets/img/nodata.png" alt="No Data" style="max-width:200px; margin:auto;" />
                        </CCol>
                    </CCol>
                </CRow>
            </CCol>
        </div>
        <div v-if="detailevent">
            <h3 class="custom-24px-500 mb-4 text-left" @click="openlist()"><img src="../assets/img/arrow-left 2.png" width="30px" class="mr-2"/>Event List</h3>
            <h3 class="custom-24px-500 text-left">Edit Event</h3>
            <h4 class="custom-16px-500 text-left font-color-AEAEB2">Review and manage events before starting the matching process</h4>
            <h3 class="mt-4 custom-16px-500">Title</h3>
            <CInput type="text" v-model="TitleEvent"/>
            <CRow>
                <CCol sm="6">
                    <h3 class="custom-16px-500">Price</h3>
                    <CInput type="text" v-model="AmountEvent"/>
                </CCol>
                <CCol sm="6">
                    <h3 class="custom-16px-500">Additional fees per member(RM)</h3>
                    <CInput type="text" v-model="ChargePerMemberEvent" />
                </CCol>
                <CCol sm="4">
                    <h3 class="custom-16px-500">Organizer</h3>
                    <CInput type="text" v-model="OrganizerEvent"/>
                </CCol>
                <CCol sm="4">
                    <h3 class="custom-16px-500">Sport Category</h3>
                    <CInput type="text" v-model="CategoryEvent"/>
                </CCol>
                <CCol sm="4">
                    <h3 class="custom-16px-500">Location</h3>
                    <CInput type="text" v-model="LocationEvent"/>
                </CCol>
                <CCol sm="6">
                    <h3 class="custom-16px-500">Schedule Date Start</h3>

                    <input type="datetime-local" v-model="StartEvent" class="form-control" />
                </CCol>
                <CCol sm="6">
                    <h3 class="custom-16px-500">Schedule Date End</h3>
                    <input type="datetime-local" v-model="EndEvent" class="form-control"/>
                </CCol>
                <CCol sm="6" class="mt-3">
                    <h3 class="custom-16px-500">Allow Tournament Registration</h3>
                    <input type="radio" v-model="acceptRegister" value="true"/> Yes
                    <input type="radio" v-model="acceptRegister" value="false" class="ml-2"/> No
                </CCol>
                <CCol sm="6" class="mt-3">
                    <h3 class="custom-16px-500">Event Publication Status</h3>
                    <input type="radio" v-model="publishEvent" value="true"/> Published
                    <input type="radio" v-model="publishEvent" value="false" class="ml-2"/> Pending
                </CCol>
                <CCol sm="6" class="mt-3">
                    <h3 class="custom-16px-500">Terms & Condition</h3>
                    <CCard>
                            <div class="text-center m-5">  
                                <label class="text-center m-0 font-inter">
                                    <input type="file" 
                                        id="editterms" 
                                        ref="editmyterms" 
                                        style="display:none;" 
                                        @change="onFileChangeTermsEdit" /><br /><br />

                                        <div id="preview">
                                            <object v-if="urlTermsEdit" :data="urlTermsEdit" type="application/pdf" width="100%" height="500px">
    <p>Your browser does not support PDFs. Please download the PDF to view it: <a :href="urlTermsEdit">Download PDF</a>.</p>
</object>
                                        </div>
                                        <div v-if="hideTerms">
                                            <object v-if="FilePathTerms" :data="FilePathTerms" type="application/pdf" width="100%" height="280px">
    <p>Your browser does not support PDFs. Please download the PDF to view it: <a :href="FilePathTerms">Download PDF</a>.</p>
</object>
                                    
                                        </div>
                                    <br />  <br />
                                    <span class="font-color-6941C6" @change="onFileChangeTermsEdit">Click to upload</span> <span class="font-color-696969"><br />
                                        SVG, PNG, JPG or GIF (max. 800x400px)
                                    </span>
                                </label>
                            </div>
                     </CCard>
                </CCol>
                <CCol sm="6" class="mt-3">
                    <h3 class="custom-16px-500">Thumbnail</h3>
                        <CCard>
                            <div class="text-center m-5">  
                                <label class="text-center m-0 font-inter">
                                    <input type="file" 
                                        id="editthumbnail" 
                                        ref="editmythumbnail" 
                                        style="display:none;" 
                                        @change="onFileChangeThumbnailEdit" /><br /><br />

                                        <div id="preview-img">
                                            <img style="max-width: 100%" v-if="urlThumbnailEdit" :src="urlThumbnailEdit" class="border-16px"/>
                                        </div>
                                        <div v-if="hideImg">
                                            <img v-if="FilePathEvent != null" :src="FilePathEvent" style="max-width: 200px" class="border-16px"/>
                                        </div>
                                    <br />  <br />
                                    <span class="font-color-6941C6" @change="onFileChangeThumbnailEdit">Click to upload</span> <span class="font-color-696969"><br />
                                        SVG, PNG, JPG or GIF (max. 800x400px)
                                    </span>
                                </label>
                            </div>
                        </CCard>
                </CCol>
                <!-- <CCol sm="4" class="mt-2">
                    <h3 class="custom-16px-500">Banner</h3>
                    <CCard>
                            <div class="text-center m-5">  
                                <label class="text-center m-0 font-inter">
                                    <input type="file" 
                                        id="editbanner" 
                                        ref="editmybanner" 
                                        style="display:none;" 
                                        @change="onFileChangeBannerEdit" /><br /><br />

                                        <div id="preview-banner">
                                            <img style="max-width: 100%" v-if="urlBannerEdit" :src="urlBannerEdit" class="border-16px"/>
                                        </div>
                                        <div v-if="hideImgBanner">
                                            <img v-if="FilePathBannerEvent != null" :src="FilePathBannerEvent" style="max-width: 200px" class="border-16px"/>
                                        </div>
                                    <br />  <br />
                                    <span class="font-color-6941C6" @change="onFileChangeBannerEdit">Click to upload</span> <span class="font-color-696969"><br />
                                        SVG, PNG, JPG or GIF (max. 800x400px)
                                    </span>
                                </label>
                            </div>
                        </CCard>
                </CCol> -->
                <CCol sm="12">
                    <h3 class="custom-16px-500">Description</h3>
                    <tinymce id="d1" v-model="ContentEvent" placeholder="Enter Your Information Tournament"></tinymce>
                </CCol>
                <CCol sm="12">
                    <div v-if="SubmittedForm === true" class="mt-3">
                                            <label>Loading....</label>
                                        </div>
                    <div v-if="SuccessMessage == true" class="mt-3">
                        <CAlert show color="success">Successfully to Save Detail</CAlert>
                    </div>
                </CCol>
                <CCol sm="6">
                    <div class="custom-btn-white mt-3 custom-border-radius-12px">
                            <div class="text-center">
                                <span class="custom-14px-600 font-color-171717 ml-2 ">Cancel</span>
                            </div>
                        </div>
                </CCol>
                <CCol sm="6">
                    <CButton class="button-Explore text-white custom-border-radius-12px mt-3" v-on:click="UpdateEvent" block size="lg">Save</CButton>
                </CCol>
                
             
            </CRow>
            <br /><br />
        </div>

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/success.png" />
                        <h3 class="custom-18px-400 font-color-171717 text-center mt-3">
                            Your data save successfully
                        </h3>
                        <CButton class="custom-bg-border-AEAEB2" @click="closeSuccess" style="width:100px">
                            <span class="ml-2 mr-2">OK</span>
                        </CButton>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";
import moment from "moment";
Vue.use(require("vue-moment"));
Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,
            tour: [],
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            detailevent: false,
            showlistevent: true,
            detail: {},

            editthumbnail: [],
            urlThumbnailEdit: null,
            hideImg: true,

            TitleEvent: "",
            AmountEvent: 0,
            ChargePerMemberEvent: 0,
            OrganizerEvent: "",
            CategoryEvent: "",
            LocationEvent: "",
            StartEvent: "",
            EndEvent: "",
            FilePathEvent: "",
            FilePathBannerEvent: "",
            FilePathTerms: "",
            editbanner: [],
            urlBannerEdit: null,
            hideImgBanner:true,
            hideTerms: true,
            editterms: [],
            urlTermsEdit: null,
            acceptRegister: false,
            publishEvent: false,
            SuccessMessage: false,
            SubmittedForm: false,
            ContentEvent: "",
            isPopupSuccess: false



        };
    },
    created() {
        AOS.init();

    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler() {
                this.$forceUpdate(); // Forces re-render on language change
            }
        }
    },
    computed: {
        CreationDate() {
            return moment().startOf('day'); // Start of today
        },
        daysInMonth() {
            const days = [];
            const date = new Date(this.currentYear, this.currentMonth, 1);

            // Adjust start date to Sunday of the week
            date.setDate(date.getDate() - date.getDay());

            // Loop through each day in the calendar grid (5-6 weeks typically)
            for (let i = 0; i < 42; i++) {
                const dayEvents = this.getEventsForDate(date);
                days.push({ date: new Date(date), events: dayEvents });
                date.setDate(date.getDate() + 1); // Go to next day
            }
            return days;
        },
        monthName() {
            return new Date(this.currentYear, this.currentMonth).toLocaleString("default", { month: "long" });
        }
    },
    async mounted() {

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
               await this.GetListTour();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
          async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        isTimeAfterToday(time) {
            const itemTime = moment(time).startOf('day');
            return itemTime.isAfter(this.CreationDate);
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GetListTour() {
            this.$API
                .get(this.$GetListTournamentByUserId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                        this.getThumbnail(this.tour.FilePath);
                    }
                });
        },
        getThumbnail(index) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.tour[index].FilePath
            );
        },
        GoToDetail(id) {
            this.$router.push("RegisterGames?id=" + id);
        },
        getEventsForDate(date) {
            // Get events that match the specific day
            return this.tour.filter(event => {
                const eventDate = new Date(event.Start);
                return (
                    eventDate.getFullYear() === date.getFullYear() &&
                    eventDate.getMonth() === date.getMonth() &&
                    eventDate.getDate() === date.getDate()
                );
            });
        },
        isToday(date) {
            const today = new Date();
            return (
                today.getFullYear() === date.getFullYear() &&
                today.getMonth() === date.getMonth() &&
                today.getDate() === date.getDate()
            );
        },
        previousMonth() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
        },
        nextMonth() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
        },
        GoToEvent()
        {
            this.$router.push("CreateEvent");
        },
        showdetail(item)
        {  this.$forceUpdate();
            this.detailevent = true;
            this.showlistevent = false;
            this.GetListTour();
            this.GetListTourBYId(item.Id);
       
           
          
        },
        async GetListTourBYId(id) {
            this.$API
                .get(this.$GetListTourById + "?id=" + id)
                .then((response) => {
                    if (response.status === 200) {
                    this.info = response.data;
                    if (response.status == 200 && this.info != null) {
                        this.Tournamentid = this.info.Id;
                        this.TitleEvent = this.info.Title;
                        this.AmountEvent = this.info.Amount;
                        this.ChargePerMemberEvent = this.info.ChargePerMember;
                        this.OrganizerEvent = this.info.Organizer;
                        this.CategoryEvent = this.info.Category;
                        this.LocationEvent = this.info.Location
                        this.StartEvent = this.info.Start;
                        this.EndEvent = this.info.End;
                        this.FilePathEvent = "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.info.FilePath;
                        this.FilePathBannerEvent = "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.info.FilePath;
                        this.FilePathTerms = "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.info.FilePathTerms;
                        this.ContentEvent = this.info.Content;
                        this.acceptRegister = this.info.IsAcceptRegistration;
                        this.publishEvent = this.info.IsPublished;

                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            });
        },
        getThumbnailDetail(FilePath) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + FilePath
            );
        },
        getBannerDetail(FilePathBanner) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + FilePathBanner
            );
        },
        openlist()
        { 
            this.detailevent = false;
            this.showlistevent = true;
           
        },
        onFileChangeThumbnailEdit(event) {
            this.hideImg = false;
            const file = event.target.files[0];
            if (file) {
                this.urlThumbnailEdit = URL.createObjectURL(file); // Preview URL
                this.editthumbnail = file; // Store the file directly
                console.log(file);
               // this.UpdateThumbnail();
            }
        },
       
        onFileChangeBannerEdit(event) {
            this.hideImgBanner = false;
            const file = event.target.files[0];
            if (file) {
                this.urlBannerEdit = URL.createObjectURL(file);
                this.editbanner = file;
                console.log(file);
            }
        },
        onFileChangeTermsEdit(event) {
            this.hideTerms = false;
            const file = event.target.files[0];
            if (file) {
                this.urlTermsEdit = URL.createObjectURL(file);
                this.editterms = file;
                console.log(file);
            }
        },
        UpdateEvent() {
            this.SuccessMessage = false;
            console.log("test" + this.SelectedLevel);
            this.SubmittedForm = true;


            const formData = new FormData();
            formData.append("Title", this.TitleEvent);
            formData.append("Amount", this.AmountEvent);
            formData.append("Category", this.CategoryEvent);
            formData.append("Location", this.LocationEvent);
            formData.append("Content", this.ContentEvent);
            // formData.append("thumbnail", this.editthumbnail[0]);
            // formData.append("banner", this.editbanner[0]);
            formData.append("ScheduleDateTime", this.StartEvent);
            formData.append("ScheduleDateTimeEnd", this.EndEvent);
            formData.append("ChargePerMember", this.ChargePerMemberEvent);
            formData.append("Organizer", this.OrganizerEvent);
            // formData.append("terms", this.editterms[0]);
            formData.append("OrganizerUserId", this.user.id);
            formData.append("IsAcceptRegistration", this.acceptRegister);
            formData.append("IsPublish", this.publishEvent);
            formData.append("Id", this.Tournamentid);


             // Append thumbnail if it exists and is not null
             if (this.editthumbnail && this.editthumbnail.size > 0) {
    formData.append("thumbnail", this.editthumbnail);
}

    // Append banner if it exists and is not null
    if (this.editbanner && this.editbanner.size > 0) {
        formData.append("banner", this.editbanner);
    }

    // Append terms if it exists and is not null
    if (this.editterms && this.editterms.size > 0) {
        formData.append("terms", this.editterms);
    }




            return this.$API
                .post(this.$UploadTournament, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;

                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                        this.SubmittedForm = false;
                        this.GetListTour();
                        this.GetListTourBYId(this.Tournamentid);
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeSuccess()
        {
            this.isPopupSuccess = false;
            this.$forceUpdate();
            location.reload();
        }





    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
.image-container {
  position: relative;
  display: inline-block;
  max-width: 100%;
  border-radius: 20px;
}

/* Style the image */
.image {
  display: block;
  max-width: 100%;
  border-radius: 20px;
}

/* Style the overlay text */
.overlay-text-right {
  position: absolute;
  top: 10px; /* Adjust the vertical position */
  right: 10px; /* Adjust the horizontal position */
  background: #fff; /* Optional: background for better readability */
  color: #064BB4; /* Text color */
  padding: 5px 10px; /* Padding around the text */
  border-radius: 5px; /* Optional: rounded corners */
  font-size: 14px; /* Adjust the font size */
  width: min-content;
}
.overlay-text-left {
  position: absolute;
  top: 10px; /* Adjust the vertical position */
  left: 10px; /* Adjust the horizontal position */
  background: #064BB4; /* Optional: background for better readability */
  color: #fff; /* Text color */
  padding: 5px 10px; /* Padding around the text */
  border-radius: 5px; /* Optional: rounded corners */
  font-size: 14px; /* Adjust the font size */
  width: min-content;
}
</style>